import { AdyenCheckout, PaymentAction } from '@adyen/adyen-web';

import { ThreeDSProvider, ThreeDSProviderConfig } from '.';

const actionMock: PaymentAction = {
  paymentData: 'Ab02b4c0!BQABAgCGWQZs0L9eiHdkoMAtw',
  paymentMethodType: 'scheme',
  authorisationToken: 'Ab02b4c0!BQABAgB2/OkgDzppRF/lKJi',
  subtype: 'challenge',
  token: 'eyJhY3NSZWZlcmVuY2VOdW1iZXIiOiJB',
  type: 'threeDS2'
};

export class AdyenThreeDSProvider implements ThreeDSProvider {
  async init(config: ThreeDSProviderConfig): Promise<void> {
    try {
      let actionData: PaymentAction;

      if (config.threeDsData?.action) {
        actionData = {
          ...config.threeDsData.action,
          type: config.threeDsData.action.type as PaymentAction['type']
        };
      } else {
        actionData = actionMock;
      }

      const clientKey =
        config.owner === 'bileto'
          ? process.env.NEXT_PUBLIC_ADYEN_CLIENT_KEY_BILETO
          : process.env.NEXT_PUBLIC_ADYEN_CLIENT_KEY_DIY;

      const checkout = await AdyenCheckout({
        environment: config.environment === 'production' ? 'live' : 'test',
        clientKey,
        countryCode: 'BR',
        locale: 'pt-BR',
        analytics: {
          enabled: false
        },
        onAdditionalDetails: async (state) => {
          // eslint-disable-next-line no-console
          console.log('state', state);
          try {
            config.onSuccess(state);
          } catch (error) {
            throw new Error(
              error instanceof Error ? error.message : String(error)
            );
          }
        },
        onError: (err: Error) => {
          // eslint-disable-next-line no-console
          console.log('err', err);
          config.onError({
            message: err instanceof Error ? err.message : String(err),
            stack: err instanceof Error ? err.stack : undefined,
            fullObjectError: err
          });
        }
      });

      checkout
        .createFromAction(actionData, { challengeWindowSize: '03' })
        .mount(config.elementId);
    } catch (error) {
      const errorMessage =
        error instanceof Error
          ? error.message
          : 'Failed to initialize Adyen 3DS SDK';

      config.onError({
        message: errorMessage
      });
    }
  }
}
